export enum GshopVariantFieldType {
  OfferId = "offer_id",
  Price = "price",
  SalePrice = "sale_price",
  Availability = "availability",
  Condition = "condition",
  Gtin = "gtin",
  Mpn = "mpn",
  ShippingWeight = "shipping_weight",
  ShippingLength = "shipping_length",
  ShippingWidth = "shipping_width",
  ShippingHeight = "shipping_height",
  Color = "color",
  Size = "size",
  Material = "material",
  Pattern = "pattern",
  AgeGroup = "age_group",
  Gender = "gender",
}
